import React, { useState, useEffect } from "react";
import Data from "../App";
import { map, distinctUntilChanged } from "rxjs/operators";
import { Primitives } from "../primitives";
import CompAttrEditView from "./CompAttrEditView";
import CompAttrView from "./CompAttrView";
import CompView from "./CompView";
import CompAddList from "./CompAddList";
import CompAddTypeSelector from "./CompAddTypeSelector";
import { List, Map, is, fromJS } from "immutable";

const CompTemplateView = ({
  spec,
  template,
  superType,
  editing,
  expanded,
  states,
  onChange
}) => {
  const [needTypeSelect, setNeedTypeSelect] = useState(null);
  const [templatesMap, setTemplatesMap] = useState(null);
  console.log("CompTemplateView " + spec);
  useEffect(() => {
    const tempMapSub = Data.getInstance()
      .getCompTemplatesMapping()
      .subscribe(tempMap => {
        setTemplatesMap(tempMap);
      });
    return () => {
      tempMapSub.unsubscribe();
    };
  }, []);

  function handleAddCompTempSelected(attr, typeTemplate) {
    setNeedTypeSelect(null);
    addTemplateAttr(attr, typeTemplate);
  }

  function handleAddAttrItem(attr) {
    console.log("handleAddAttrItem " + attr);
    let attrTypeName = attr.get("type");
    if (Primitives.indexOf(attrTypeName) >= 0) {
      addAttrValue(attr, "tbd");
    } else if (attrTypeName === "ui-binding") {
      addCompAttr(
        attr,
        fromJS({
          type: attrTypeName,
          attribute: "tbd",
          cases: [{ case: "case", case_value: "value" }]
        })
      );
    } else {
      let typeTemplates = templatesMap.get(attrTypeName);
      console.log("handleAddAttrItem t" + typeTemplates);
      if (typeTemplates) {
        if (typeTemplates.size > 1) setNeedTypeSelect([attr, typeTemplates]);
        else addTemplateAttr(attr, typeTemplates.get(0));
      }
    }
  }

  function addAttrValue(attr, value) {
    console.log("handleAddMultiAttrItem " + spec.get(attr.get("attr")));
    if (!spec.get(attr.get("attr"))) {
      let toAdd;
      if (attr.get("quant") === "n?" || attr.get("quant") === "n!")
        toAdd = new List([value]);
      else toAdd = value;
      onChange(spec.set(attr.get("attr"), toAdd));
    } else {
      console.log(
        "handleAddMultiAttrItem " +
          spec.get(attr.get("attr")) +
          " TO: " +
          spec.updateIn([attr.get("attr")], list => list.push(value))
      );
      onChange(spec.updateIn([attr.get("attr")], list => list.push(value)));
    }
  }

  function addTemplateAttr(attr, typeTemplate) {
    console.log("addTemplateAttr " + typeTemplate);
    let comp = new Map({
      type: typeTemplate.get("type"),
      name: typeTemplate.get("name") ? typeTemplate.get("name") : "tbd"
    });
    console.log("addTemplateAttr new " + comp);
    addCompAttr(attr, comp);
  }

  function addCompAttr(attr, comp) {
    let addedId = Data.getInstance().addComp(comp);
    addAttrValue(attr, addedId);
  }

  function handleAttrChange(attrName, value, indexForMulti) {
    console.log(
      "handleAttrChange " +
        attrName +
        " -> " +
        value +
        " (current: " +
        spec.get(attrName)
    );

    if (indexForMulti) {
      console.log(
        "handleAttrChange Multi pre " +
          spec.get(attrName) +
          "  index: " +
          indexForMulti +
          " TO: " +
          spec.setIn([attrName, indexForMulti], value)
      );
      onChange(spec.setIn([attrName, indexForMulti], value));
    } else {
      onChange(spec.set(attrName, value));
    }
  }

  function handleAttrDelete(attrName, indexForMulti) {
    if (indexForMulti) {
      onChange(spec.deleteIn([attrName, indexForMulti]));
    } else {
      onChange(spec.delete(attrName));
    }
  }

  function getAttr(attr, value, indexForMulti) {
    console.log("getAttr " + JSON.stringify(value));
    let key = attr.get("attr") + (indexForMulti ? indexForMulti : "");
    if (editing)
      return (
        <CompAttrEditView
          key={key}
          attr={attr}
          attrValue={value}
          states={states}
          handleAttrChange={newValue =>
            handleAttrChange(attr.get("attr"), newValue, indexForMulti)
          }
        />
      );
    else
      return (
        <CompAttrView
          key={key}
          attr={attr}
          attrValue={value}
          superType={superType}
          states={states}
        />
      );
  }
  function getChildComp(attr, value, indexForMulti) {
    if (!value) return "";
    let key = attr.get("attr") + (indexForMulti ? indexForMulti : "");
    return (
      <CompView
        key={key}
        compId={value}
        parentStates={states}
        onDelete={() => handleAttrDelete(attr.get("attr"), indexForMulti)}
      />
    );
  }
  function getCompForAttr(attr, value, indexForMulti) {
    if (Primitives.indexOf(attr.get("type")) >= 0) {
      if (attr.get("type") !== "name" && !expanded) return "";
      return getAttr(attr, value, indexForMulti);
    } else {
      return getChildComp(attr, value, indexForMulti);
    }
  }

  let typeSelect = "";
  if (needTypeSelect)
    typeSelect = (
      <CompAddTypeSelector
        typeTemplates={needTypeSelect[1]}
        attr={needTypeSelect[0]}
        selected={handleAddCompTempSelected}
      />
    );
  let addList = "";
  if (editing)
    addList = (
      <CompAddList
        attributes={template.get("attributes")}
        spec={spec}
        addNew={handleAddAttrItem}
      />
    );
  return (
    <div>
      {typeSelect}
      {template.get("attributes").map(attr => {
        let isMulti = attr.get("quant") === "n?" || attr.get("quant") === "n!";
        let value = spec.get(attr.get("attr"));
        console.log(
          "CompTemplate " + attr + "  VAL: " + value + "EXP: " + expanded
        );
        if (!value) return "";
        if (isMulti) {
          return value.map((item, index) => {
            return getCompForAttr(attr, item, index);
          });
        } else return getCompForAttr(attr, value, null);
      })}
      {addList}
    </div>
  );
};
export default CompTemplateView;



// WEBPACK FOOTER //
// ./src/components/CompTemplateView.js